/* eslint no-console: 0 */
/* global axios */
import ApiClient from '../ApiClient';
import { LOCAL_STORAGE_KEYS } from 'dashboard/constants/localStorage';
import { LocalStorage } from 'shared/helpers/localStorage';

export const buildCreatePayload = ({
  message,
  isPrivate,
  contentAttributes,
  echoId,
  files,
  ccEmails = '',
  bccEmails = '',
  templateParams,
  replyTo,
}) => {
  let payload;

  if (files && files.length !== 0) {
    payload = new FormData();
    if (message) {
      payload.append('content', message);
    }
    files.forEach(file => {
      payload.append('attachments[]', file);
    });
    payload.append('private', isPrivate);
    payload.append('echo_id', echoId);
    payload.append('cc_emails', ccEmails);
    payload.append('bcc_emails', bccEmails);

    if (replyTo) {
      payload.append('reply_to[content]', replyTo.content);
      payload.append('reply_to[source_id]', replyTo.source_id);
    }
  } else {
    payload = {
      content: message,
      private: isPrivate,
      echo_id: echoId,
      content_attributes: contentAttributes,
      cc_emails: ccEmails,
      bcc_emails: bccEmails,
      template_params: templateParams,
    };

    if (replyTo) {
      payload.content_attributes = {
        ...payload.content_attributes,
        reply_to: replyTo,
      };
    }    
  }

  return payload;
};

class MessageApi extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  create({
    conversationId,
    message,
    private: isPrivate,
    contentAttributes,
    echo_id: echoId,
    files,
    ccEmails = '',
    bccEmails = '',
    templateParams,
    reply_to: replyTo,
  }) {
    return axios({
      method: 'post',
      url: `${this.url}/${conversationId}/messages`,
      data: buildCreatePayload({
        message,
        isPrivate,
        contentAttributes,
        echoId,
        files,
        ccEmails,
        bccEmails,
        templateParams,
        replyTo,
      }),
    });
  }

  delete(conversationID, messageId) {
    return axios.delete(`${this.url}/${conversationID}/messages/${messageId}`);
  }

  getPreviousMessages({ conversationId, after, before }) {
    const params = { before };
    if (after && Number(after) !== Number(before)) {
      params.after = after;
    }
    if (LocalStorage.get(LOCAL_STORAGE_KEYS.SHOW_LOG_CONVERSATION) === true) {
      params.showlogs = true;
    }
    return axios.get(`${this.url}/${conversationId}/messages`, { params });
  }

  translateMessage(conversationId, messageId, targetLanguage) {
    return axios.post(
      `${this.url}/${conversationId}/messages/${messageId}/translate`,
      {
        target_language: targetLanguage,
      }
    );
  }

  forwardMessage(conversationId, messageId, contacts) {
    return axios.post(
      `${this.url}/${conversationId}/messages/${messageId}/forward`,
      {
        contacts,
      }
    );
  }

  hideMessage(conversationId, messageId) {
    return axios.put(`${this.url}/${conversationId}/messages/${messageId}/hide`);
  }

  unhideMessage(conversationId, messageId) {
    return axios.put(
      `${this.url}/${conversationId}/messages/${messageId}/unhide`
    );
  }
}

export default new MessageApi();
